var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_274_7487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0422 31.7696C24.8364 31.7696 31.9655 24.6972 31.9655 15.9728C31.9655 7.24848 24.8364 0.176 16.0422 0.176C7.24811 0.176 0.119049 7.24848 0.119049 15.9728C0.119049 24.6972 7.24811 31.7696 16.0422 31.7696Z",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7395 17.4306V17.4281C17.6295 17.4357 17.0611 17.4687 15.7965 17.4687C14.7853 17.4687 14.0762 17.4408 13.8253 17.4281V17.4306C9.93665 17.2604 7.03617 16.59 7.03617 15.7849C7.03617 14.9823 9.93921 14.3093 13.8253 14.1392V16.7627C14.0787 16.7804 14.8083 16.8236 15.8144 16.8236C17.0227 16.8236 17.6269 16.7728 17.7395 16.7627V14.1417C21.6205 14.3144 24.5133 14.9849 24.5133 15.7874C24.5133 16.59 21.6179 17.2604 17.7395 17.4331M17.7395 13.87V11.5233H23.1539V7.94489H8.41345V11.5233H13.8278V13.87C9.42721 14.0706 6.11969 14.9341 6.11969 15.9703C6.11969 17.0065 9.42977 17.87 13.8278 18.0731V25.5957H17.7421V18.0731C22.1351 17.8725 25.4375 17.009 25.4375 15.9728C25.4375 14.9392 22.1351 14.0731 17.7421 13.8725"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_274_7487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.4f3199e4eb4a1f2f023740c5f9f10328.svg";
export { ForwardRef as ReactComponent };